var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"SmallBadge",style:([_vm.value === 'PUBLIC' ? {'background-color' : '#9abdd4'} : {'background-color': _vm.bgColor}])},[_vm._v(_vm._s(_vm.value))])
}
var staticRenderFns = []

export { render, staticRenderFns }